import React from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import styles from './AudioSlider.module.scss'

export const AudioSlider = ({
    value,
    onChange,
}: {
    value: number
    onChange: (value: number) => void
}) => (
    <Slider
        className={styles.sliderWrapper}
        max={1}
        min={0}
        onChange={onChange}
        step={0.01}
        value={value}
    />
)
